import { call, put, takeEvery } from 'redux-saga/effects';

import {
    FETCH_ADAPTIVE_COACHING_PLAN,
    FETCH_ADAPTIVE_COACHING_PLAN_FETCHING,
    FETCH_ADAPTIVE_COACHING_PLAN_SUCCESS,
    FETCH_ADAPTIVE_COACHING_PLAN_FAIL,
    FETCH_ADAPTIVE_COACHING_EVENTS,
    FETCH_ADAPTIVE_COACHING_EVENTS_FETCHING,
    FETCH_ADAPTIVE_COACHING_EVENTS_SUCCESS,
    FETCH_ADAPTIVE_COACHING_EVENTS_FAIL,
    UPDATE_ADAPTIVE_COACHING_TRAINING_VERSION,
    UPDATE_ADAPTIVE_COACHING_TRAINING_VERSION_UPDATING,
    UPDATE_ADAPTIVE_COACHING_TRAINING_VERSION_SUCCESS,
    UPDATE_ADAPTIVE_COACHING_TRAINING_VERSION_FAIL,
    DELETE_ADAPTIVE_COACHING_PLAN,
    DELETING_ADAPTIVE_COACHING_PLAN,
    DELETE_ADAPTIVE_COACHING_PLAN_SUCCESS,
    DELETE_ADAPTIVE_COACHING_PLAN_FAIL
} from 'actions/ActionTypes';

import { gcApi } from '../config/axios';

// Utils
import { handlingErrorCallback, handlingSuccessCallback } from 'sagas/sagasUtils';
import { TRAINING_STATUS_KEYS } from 'DSW/utils/DswUtils';

export function* fetchAdaptiveCoachPlanSaga(action) {
    const { trainingPlanId } = action;

    try {
        yield put({
            type: FETCH_ADAPTIVE_COACHING_PLAN_FETCHING,
            trainingPlanId
        });

        const response = yield call(gcApi.get, `/trainingplan-service/trainingplan/fbt-adaptive/${trainingPlanId}`);

        yield put({
            type: FETCH_ADAPTIVE_COACHING_PLAN_SUCCESS,
            adaptiveCoachPlan: response.data,
            trainingPlanId
        });
    } catch (e) {
        yield put({
            type: FETCH_ADAPTIVE_COACHING_PLAN_FAIL,
            trainingPlanId
        });
    }
}

export function* fetchAdaptiveCoachPlanEventsSaga(action) {
    const { trainingPlanId } = action;

    try {
        yield put({
            type: FETCH_ADAPTIVE_COACHING_EVENTS_FETCHING,
            trainingPlanId
        });
        // Hardcoded startDate to 1995-01-01 as a catch-all to get events after they have been completed
        const response = yield call(
            gcApi.get,
            `/calendar-service/events?trainingPlanId=${trainingPlanId}&startDate=1995-01-01`
        );

        yield put({
            type: FETCH_ADAPTIVE_COACHING_EVENTS_SUCCESS,
            adaptiveCoachPlanEvents: response.data,
            trainingPlanId
        });
    } catch (e) {
        yield put({
            type: FETCH_ADAPTIVE_COACHING_EVENTS_FAIL,
            trainingPlanId
        });
    }
}

export function* updateAdaptiveCoachPlanTrainingVersionSaga(action) {
    const { versionName, trainingPlanId } = action;

    try {
        yield put({
            type: UPDATE_ADAPTIVE_COACHING_TRAINING_VERSION_UPDATING
        });

        yield call(gcApi.put, `/trainingplan-service/trainingplan/fbt-adaptive/${trainingPlanId}/trainingVersion`, {
            versionName: versionName
        });

        yield put({
            type: UPDATE_ADAPTIVE_COACHING_TRAINING_VERSION_SUCCESS
        });

        if (action.callback) {
            yield call(handlingSuccessCallback, action.callback, true);
        }
    } catch (e) {
        yield put({ type: UPDATE_ADAPTIVE_COACHING_TRAINING_VERSION_FAIL });
        if (action.callback) {
            yield call(handlingErrorCallback, action.callback, false);
        }
    }
}

export function* deleteAdaptiveCoachPlanSaga(action) {
    const { trainingPlanId } = action;

    try {
        yield put({
            type: DELETING_ADAPTIVE_COACHING_PLAN
        });

        yield call(gcApi.delete, `/trainingplan-service/trainingplan/trainingplan/${trainingPlanId}`);

        yield put({
            type: DELETE_ADAPTIVE_COACHING_PLAN_SUCCESS
        });

        if (action.callback) {
            yield call(handlingSuccessCallback, action.callback, true);
        }
    } catch (e) {
        yield put({ type: DELETE_ADAPTIVE_COACHING_PLAN_FAIL });
        if (action.callback) {
            yield call(handlingErrorCallback, action.callback, false);
        }
    }
}

export const ftbAdaptiveCoachingTrainingPlanSagas = [
    takeEvery(FETCH_ADAPTIVE_COACHING_PLAN, fetchAdaptiveCoachPlanSaga),
    takeEvery(FETCH_ADAPTIVE_COACHING_EVENTS, fetchAdaptiveCoachPlanEventsSaga),
    takeEvery(UPDATE_ADAPTIVE_COACHING_TRAINING_VERSION, updateAdaptiveCoachPlanTrainingVersionSaga),
    takeEvery(DELETE_ADAPTIVE_COACHING_PLAN, deleteAdaptiveCoachPlanSaga)
];
